export default __webpack_public_path__ + "static/media/logo01.2bff1583.webp";